import loggingService from '../util/loggingService'

var serviceName = 'locationService'
var path = '/CulturalResourceLocation/'
var isDebug = false

function put (http, location) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, location)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?culturalResourceLocationId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'searching')
    return http.post(path + 'Search', searchObject).then(response => {
        loggingService.log(isDebug, serviceName, 'search complete')
        return response
    })
}

export default {
    put: put,
    get: get,
    search: search
}




// WEBPACK FOOTER //
// ./src/services/siteForm/locationService.js